import { render } from "./SetResetPassword.vue?vue&type=template&id=7caf3e15&scoped=true"
import script from "./SetResetPassword.vue?vue&type=script&lang=js"
export * from "./SetResetPassword.vue?vue&type=script&lang=js"

import "./SetResetPassword.vue?vue&type=style&index=0&id=7caf3e15&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caf3e15"]])

export default __exports__